class DateCounter extends HTMLElement {
    constructor() {
      super();
      this.countdownDateAttr = this.getAttribute('data-countdown-date');
      this.countdownDate = new Date(this.countdownDateAttr);
      if (isNaN(this.countdownDate)) {
        console.error('Invalid date format:', this.countdownDateAttr);
        this.querySelector('.countdown-timer').textContent = "Date invalide";
        return;
      }
    }
  
    connectedCallback() {
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }
  
    disconnectedCallback() {
      clearInterval(this.interval);
    }
  
    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.countdownDate.getTime() - now;
  
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      let displayTime;
      if (distance > 24 * 60 * 60 * 1000) {
        displayTime = `${days}j ${hours}h ${minutes}min ${seconds}sec`;
      } else {
        displayTime = `${hours}h ${minutes}min ${seconds}sec`;
      }
  
      this.querySelector('.countdown-timer').textContent = displayTime;
  
      if (distance < 0) {
        this.style.display = "none";
        clearInterval(this.interval);
      }
    }
  }
  
  customElements.define('date-counter', DateCounter);
  